/**
 * Yapılandırma sayfasının metni (NFR-04: istem şablonları).
 *
 * `metin/ortak.ts`in kuralı burada da geçerli: metin veri, koda serpiştirilmiş dize değil. Kod
 * değerleri (`REQUEST_PARSING`, `QUOTE_NARRATIVE`) çevrilmiyor; yalnız ekrana yazılırken
 * karşılığı gösteriliyor.
 */

/**
 * Şablon anahtarlarının karşılığı.
 *
 * Anahtar ekranda **kod olarak da** duruyor (satırın kimliği o), ama başlıkta operatörün okuduğu
 * ad yazıyor: bir şablonu değiştirecek kişinin, o şablonun hangi işi yaptığını bilmesi gerekiyor.
 */
export const ISTEM_SABLONU_ADI: Readonly<Record<string, string>> = {
  REQUEST_PARSING: 'Talep ayrıştırma',
  QUOTE_NARRATIVE: 'Teklif anlatımı',
};

export const ISTEM_SABLONU_ISI: Readonly<Record<string, string>> = {
  REQUEST_PARSING:
    'Müşterinin serbest metnini yapılandırılmış alanlara çeviren istem. Aktif sürüm yoksa alanlar hiç doldurulmaz ve satışçı hepsini elle yazar.',
  QUOTE_NARRATIVE: 'Teklif metnini yazan istem. Aktif sürüm yoksa teklif anlatımı üretilmez.',
};

export const YAPILANDIRMA_METIN = {
  ustBaslik: 'SİSTEM',
  baslik: 'Yapılandırma',
  tarif:
    'Kod dağıtımı gerektirmeden değişen çalışma zamanı ayarları. Buradaki her değişiklik bütün kullanıcıları etkiler; tarayıcıya değil sunucuya yazılır.',

  istem: {
    baslik: 'İstem şablonları',
    tarif:
      'Her anahtar için en fazla bir sürüm etkin olabilir. Etkin sürüm yoksa çağrı hiç yapılmaz ve iş elle yürür — bu bir arıza değil, bir durum, ve düzeltmenin yolu yeni bir sürüm yazmak ya da eski bir sürümü etkinleştirmek.',
    hata: 'İstem şablonları okunamadı.',
    bos: 'Bu anahtar için hiç sürüm yazılmamış. Etkin sürüm olmadığı sürece alanlar elle dolduruluyor.',
    etkinYok: 'Etkin sürüm yok',
    etkinSurum: (surum: string) => `Etkin sürüm: ${surum}`,
    sutunSurum: 'Sürüm',
    sutunDurum: 'Durum',
    sutunNot: 'Değişiklik notu',
    sutunYazilma: 'Yazıldığı an',
    sutunUzunluk: 'Uzunluk',
    etkin: 'Etkin',
    pasif: 'Etkin değil',
    karakter: (adet: string) => `${adet} karakter`,
    goster: 'Metni göster',
    gizle: 'Metni gizle',
    etkinlestir: 'Bu sürümü etkinleştir',
    etkinlestirildi: (surum: string) => `${surum} numaralı sürüm etkinleştirildi; önceki sürüm kapandı.`,

    yeniBaslik: 'Yeni sürüm yaz',
    anahtarEtiketi: 'Şablon anahtarı',
    govdeEtiketi: 'Şablon metni',
    govdeIpucu: 'En az 20, en çok 16.000 karakter. Yer tutucular süslü çift parantezle yazılır.',
    notEtiketi: 'Değişiklik notu',
    notIpucu: 'Neyi neden değiştirdiğinizi yazın; sürüm listesinde okunuyor.',
    hemenEtkinEtiketi: 'Yazar yazmaz etkinleştir',
    hemenEtkinIpucu: 'İşaretlenmezse sürüm kaydedilir ama hiçbir çağrıyı etkilemez.',
    yaz: 'Sürümü yaz',
    yazildi: (surum: string) => `${surum} numaralı sürüm yazıldı.`,
    yazildiVeEtkin: (surum: string) => `${surum} numaralı sürüm yazıldı ve etkinleştirildi.`,
    govdeUyarisi: 'Şablon metni en az 20 karakter olmalı.',
    saltOkunur: 'Bu ekranı okuyabiliyorsunuz ama sürüm yazma yetkiniz yok.',
  },
} as const;
